// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IMS Management API
 * Management API for the IMS catalog: partitions, isolation units, and clusters, returned in a Kubernetes-familiar metadata/spec/status envelope (ADR-0008).
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface PartitionSpec
 */
export interface PartitionSpec {
  /**
   *
   * @type {string}
   * @memberof PartitionSpec
   */
  cloudProvider?: string;
  /**
   *
   * @type {string}
   * @memberof PartitionSpec
   */
  mode?: string;
  /**
   *
   * @type {string}
   * @memberof PartitionSpec
   */
  partitionAlias?: string;
  /**
   *
   * @type {string}
   * @memberof PartitionSpec
   */
  plane?: string;
  /**
   *
   * @type {string}
   * @memberof PartitionSpec
   */
  region?: string;
  /**
   *
   * @type {string}
   * @memberof PartitionSpec
   */
  scope?: string;
  /**
   *
   * @type {object}
   * @memberof PartitionSpec
   */
  topology?: object;
}

/**
 * Check if a given object implements the PartitionSpec interface.
 */
export function instanceOfPartitionSpec(value: object): value is PartitionSpec {
  return true;
}

export function PartitionSpecFromJSON(json: any): PartitionSpec {
  return PartitionSpecFromJSONTyped(json, false);
}

export function PartitionSpecFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PartitionSpec {
  if (json == null) {
    return json;
  }
  return {
    cloudProvider:
      json['cloud_provider'] == null ? undefined : json['cloud_provider'],
    mode: json['mode'] == null ? undefined : json['mode'],
    partitionAlias:
      json['partition_alias'] == null ? undefined : json['partition_alias'],
    plane: json['plane'] == null ? undefined : json['plane'],
    region: json['region'] == null ? undefined : json['region'],
    scope: json['scope'] == null ? undefined : json['scope'],
    topology: json['topology'] == null ? undefined : json['topology'],
  };
}

export function PartitionSpecToJSON(json: any): PartitionSpec {
  return PartitionSpecToJSONTyped(json, false);
}

export function PartitionSpecToJSONTyped(
  value?: PartitionSpec | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    cloud_provider: value['cloudProvider'],
    mode: value['mode'],
    partition_alias: value['partitionAlias'],
    plane: value['plane'],
    region: value['region'],
    scope: value['scope'],
    topology: value['topology'],
  };
}
